import React from 'react';
import PropTypes from 'prop-types';

const ErrorMessage = ({ children, onlyInfo = false }) => {
  return (
    <span className="input-error-message">
      <span className="input-error-icon-wrapper">
        <i
          className={`${
            onlyInfo
              ? 'info-icon fas fa-question'
              : 'input-error-icon fa fa-exclamation'
          }`}
          aria-hidden="true"
        />
        {children}
      </span>
    </span>
  );
};

ErrorMessage.propTypes = {
  children: PropTypes.node,
  onlyInfo: PropTypes.bool,
};

export default ErrorMessage;
